import apiFetch from '../apiFetch'

export default function (idAlbaranManual) {
  return apiFetch({endPoint: `AlbaranManual/imprimirAlbaran?idAlbaranManual=${idAlbaranManual}`, method: 'GET'})
}